import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import IntlMessages from '../../helpers/IntlMessages';
import aiva_logo from '../../assets/Switch_to_aiva.png';
import { getGroupID, getUserID } from '../../helpers/AxiosAPI';

const TopnavEasyAccess = ({ handleAivaRedirect }) => {
  return (
    <div className="position-relative d-none d-sm-inline-block">
      <UncontrolledDropdown className="dropdown-menu-right">
        <DropdownToggle className="header-icon" color="empty">
          <i className="simple-icon-grid" />
        </DropdownToggle>
        <DropdownMenu
          className="position-absolute mt-3 "
          right
          id="iconMenuDropdown"
        >
          <p className='text-center mb-2'>
            {/* <strong>Switch to</strong>*/}
            Switch to
            </p> 
          <p to=""

            className="icon-menu-item">
            <img src={aiva_logo} onClick={() => handleAivaRedirect(getGroupID())} className='aiva-item' alt="" />
          </p>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default TopnavEasyAccess;
